import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { TempletesListOptions } from 'services/templatesList';
import ToolButton from 'components/atoms/tool_button';
import { useReactToPrint } from 'react-to-print';
import FormTemplate from 'components/molecules/form_template';
import Clipboard from 'services/clipboard';
import DeclarationTemplateDocument from 'components/atoms/declaration_template_document';
import { declarationTemplateById } from 'services/declaration_templates';

interface Templete {
  value: string;
  label: string;
  description: string;
}

const DocumentGenerator = () => {
  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [templete, setTemplete] = useState<Templete>();
  const [edital, setEdital] = useState<string>('');
  const [razaoSocial, setRazaoSocial] = useState<string>('');
  const [cnpj, setCnpj] = useState<string>('');
  const [responsavel, setResponsavel] = useState<string>('');
  const [cargo, setCargo] = useState<string>('');
  const [rg, setRg] = useState<string>('');
  const [cpf, setCpf] = useState<string>('');
  const [expedidor, setExpedidor] = useState<string>('');
  const [cidade, setCidade] = useState<string>('');
  const [nomeCredenciado, setNomeCredenciado] = useState<string>('');
  const [rgCredenciado, setRgCredenciado] = useState<string>('');
  const [expedidorCredenciado, setExpedidorCredenciado] = useState<string>('');
  const [cpfCredenciado, setCpfCredenciado] = useState<string>('');
  const [alert, setAlert] = useState<string>('');

  useEffect(() => {
    document.title = 'Modelos de Declarações - ConLicitação';
  }, []);

  const modelo = declarationTemplateById(templete?.value);

  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'conlicitacao',
  });

  const copyToClipboard = () => {
    const element = document.querySelector('#documento');

    if (!element) return;

    if (Clipboard.copyElement(element))
      setAlert('Conteúdo do documento copiado para a Área de Transferência.');
  };

  return (
    <div className="page-container">
      <div className="container-fluid">
        <div className="p-md-4 p-5">
          <div className="row ">
            <div className="col-12 col-md-6">
              <h3 className="col-12 font-weight-bold p-0">Modelos de Declarações</h3>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-end p-0 text-center">
              <ToolButton
                buttonClass="btn btn-primary btn-sm mr-2"
                buttonName="Copiar conteúdo"
                disabledButton={templete?.value !== undefined}
                disabledPopoverText="Selecione pelo menos um modelo de documento"
                onButtonClick={() => copyToClipboard()}
              />
              <ToolButton
                buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
                buttonName="Imprimir"
                disabledPopoverText="Selecione pelo menos um modelo de documento"
                disabledButton={templete?.value !== undefined}
                onButtonClick={() => handleprint()}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12 col-md-4 mb-3">
              <Select
                name="role"
                className="mt-2"
                options={TempletesListOptions}
                noOptionsMessage={() => 'Selecione um template'}
                placeholder="Selecione um template"
                onChange={(selected) => {
                  setTemplete(selected as Templete);
                }}
              />
              <div className="card mt-3 p-3">
                <FormTemplate
                  template={templete?.value}
                  setEdital={setEdital}
                  edital={edital}
                  setRazaoSocial={setRazaoSocial}
                  razaoSocial={razaoSocial}
                  cnpj={cnpj}
                  setCnpj={setCnpj}
                  setResponsavel={setResponsavel}
                  responsavel={responsavel}
                  setCargo={setCargo}
                  cargo={cargo}
                  setRg={setRg}
                  rg={rg}
                  expedidor={expedidor}
                  setExpedidor={setExpedidor}
                  setCpf={setCpf}
                  cpf={cpf}
                  setCidade={setCidade}
                  cidade={cidade}
                  setNomeCredenciado={setNomeCredenciado}
                  nomeCredenciado={nomeCredenciado}
                  setRgCredenciado={setRgCredenciado}
                  rgCredenciado={rgCredenciado}
                  setExpedidorCredenciado={setExpedidorCredenciado}
                  expedidorCredenciado={expedidorCredenciado}
                  setCpfCredenciado={setCpfCredenciado}
                  cpfCredenciado={cpfCredenciado}
                />
              </div>
            </div>
            <div className="col-12 col-md-8">
              {alert !== '' && (
                <div className="alert alert-success" role="alert">
                  {alert}
                </div>
              )}
              <div className="card">
                <div className="card-title p-3 text-white dark-bg mb-0">
                  Modelo: {templete?.label}
                </div>
                <em className="p-3">
                  <span className="text-danger">IMPORTANTE:</span> observar se o modelo fornecido no
                  edital estabelece alguma informação adicional ou conflitante com este conteúdo
                  sugerido, bem como a necessidade de reconhecimento de firma nas assinaturas,
                  visando evitar a inabilitação do licitante.
                </em>
                {modelo && (
                  <DeclarationTemplateDocument
                    template={modelo}
                    componentRef={componentRef}
                    valores={{
                      edital,
                      razao_social: razaoSocial,
                      cnpj,
                      representante_nome: responsavel,
                      representante_cargo: cargo,
                      representante_rg: rg,
                      representante_rg_orgao: expedidor,
                      representante_cpf: cpf,
                      cidade,
                      credenciado_nome: nomeCredenciado,
                      credenciado_rg: rgCredenciado,
                      credenciado_rg_orgao: expedidorCredenciado,
                      credenciado_cpf: cpfCredenciado,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DocumentGenerator;
